import React from 'react';
import '../styles/ReviewsSection.css';
import placeholderImage from '../assets/business-logo.png';
import checkmark from '../assets/green-checkmark.png';
import { Link } from 'react-router-dom';

const ReviewsSection = () => {

    // Testimonial data array
const testimonials = [
  {
    id: 1,
    logo: placeholderImage,
    rating: '★★★★★',
    text: '“This is, without question, the "Best Advertising & Marketing Team" we’ve ever worked with.”',
    author: '– Clay B., Owner, Bullfrog Pool Tile Cleaning',
    link: 'https://share.google/M1C6XTGGVoHZi1eJZ'
  },
  {
    id: 2,
    logo: placeholderImage,
    rating: '★★★★★',
    text: '“We have received one on one, personal attention from marketing professionals.”',
    author: '– Revill M., Founder, CB Smith Plumbing',
    link: 'https://share.google/AlVlrGf5p5RWRy6D5'
  },
  {
    id: 3,
    logo: placeholderImage,
    rating: '★★★★★',
    text: '“They transformed our marketing approach and delivered measurable results.”',
    author: '– James P., CEO, Company Z',
    link: ''
  },
];

  return (
    <section className="reviews-section">
      {/* Title */}
      <div className="reviews-header">
        <h2 className="reviews-title">
          <span>Our Clients</span>
          <span className="highlight">REVIEWS          
                <img src={checkmark} id="checkmark" alt="Checkmark Icon" />
          </span>
        </h2>
        {/*<p className="reviews-subtitle">
          While we like the work we do, hear what our clients have to say!
        </p>*/}
      </div>

{/* Testimonial Cards */}
      <div className="reviews-cards-container">
        {testimonials.map((testimonial) => (
          <div className="review-card" key={testimonial.id}>
            <img src={testimonial.logo} alt="Business Logo" className="review-logo" />
            <div className="stars">{testimonial.rating}</div>
            <p className="review-text">{testimonial.text}</p>
            <p className="review-author">{testimonial.author}</p>
            <a
  href={testimonial.link}
  target="_blank"
  rel="noopener noreferrer"
  className="review-button"
>
  READ FULL REVIEW
</a>
          </div>
        ))}
      </div>

      {/* CTA Below Cards */}
      <div className="reviews-cta">
        <p className="reviews-cta-text">Click below to Schedule Your FREE Growth Audit!</p>
        <Link to="/lead-form" className="reviews-cta-button">Get Started</Link>
      </div>
    </section>
  );
};

export default ReviewsSection;
